export default {
    features: [],
    assembled: false
}
